(function () {
  'use strict';

  var API_BASE = window.RENNEWAY_API_BASE || '';
  var drawer, listEl, subEl, orderPane, orderForm;
  var productData = null;
  var openOfferId = null;
  var selection = { color: null, number: null };
  var currentOrderDraft = null;
  var paymentMethods = ['bank_transfer'];   // /offers yanitindan gelir; kart kapaliyken yalnizca havale
  var colorMediaMap = {};
  var buyerSession = null;          // { email, name, companyName, taxNumber, phone, addresses[] }
  var onAuthSuccess = null;         // login/register basarili olunca 1 kez cagrilir (RFQ/numune formunu yeniden acar)

  // Bearer token — cookie 3. taraf engeline takilsa da oturum sayfalar arasi tasinir
  function authHeaders(base) {
    var h = base || {};
    var tok = window.rnwToken ? window.rnwToken.get() : '';
    if (tok) h['Authorization'] = 'Bearer ' + tok;
    return h;
  }
  var variantSkuMap = {};           // 'color||number' -> sku (lowercase normalized key)
  var optionIdx = { color: -1, number: -1 };

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    drawer = document.getElementById('renneway-drawer');
    listEl = document.getElementById('renneway-offers-list');
    subEl = document.getElementById('renneway-variant-info');
    orderPane = document.getElementById('renneway-order-pane');
    orderForm = document.getElementById('renneway-order-form');
    if (!drawer) return;

    var jsonEl = document.getElementById('renneway-product-json');
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) {}
    }

    buildColorMediaMap();
    buildVariantSkuMap();
    fetchRemainingVariants();
    bindVariantDisplay();
    initStagedPicker();
    initAuthModal();
    initAuthBanner();
    refreshBuyerSession();

    // Sayfa yükünde başlangıç senkronu (URL pre-select varsa state'i yansıt)
    emitSelectionChange();

    document.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-renneway-close]');
      if (closer) { close(); return; }
      var opener = e.target.closest('[data-renneway-open]');
      if (opener) { e.preventDefault(); open(); return; }
      var back = e.target.closest('[data-order-back]');
      if (back) { showOffersList(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    if (orderForm) {
      orderForm.addEventListener('submit', onOrderSubmit);
      bindShippingToggle(orderForm);
    }
  }

  function bindShippingToggle(form) {
    var radios = form.querySelectorAll('input[name="shippingPreference"]');
    var detailsEl = form.querySelector('[data-rnw-shipping-details]');
    if (!radios.length || !detailsEl) return;
    var nameInput = detailsEl.querySelector('input[name="carrierName"]');
    var addrInput = detailsEl.querySelector('input[name="carrierAddress"]');
    function update() {
      var chosen = '';
      radios.forEach(function (r) { if (r.checked) chosen = r.value; });
      var ownCarrier = chosen === 'own_carrier';
      detailsEl.hidden = !ownCarrier;
      if (nameInput) nameInput.required = ownCarrier;
      if (addrInput) addrInput.required = ownCarrier;
      if (!ownCarrier) {
        // Clear hidden fields so stale values aren't submitted
        detailsEl.querySelectorAll('input').forEach(function (i) { i.value = ''; });
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  function initStagedPicker() {
    var buyEls = document.querySelectorAll('.renneway-buy');
    buyEls.forEach(function (buyEl) {
      var colorChips = buyEl.querySelector('[data-renneway-chips="color"]');
      var numberStep = buyEl.querySelector('[data-renneway-number-step]');
      var actionStep = buyEl.querySelector('[data-renneway-action-step]');

      if (colorChips) {
        colorChips.addEventListener('click', function (e) {
          var btn = e.target.closest('.renneway-chip');
          if (!btn) return;
          setChipSelected(colorChips, btn);
          selection.color = btn.getAttribute('data-value');
          switchGalleryToColor(selection.color);
          if (numberStep) numberStep.hidden = false;
          if (actionStep) actionStep.hidden = !selection.number;
          emitSelectionChange();
        });
      }

      var numberChips = buyEl.querySelector('[data-renneway-chips="number"]');
      if (numberChips) {
        numberChips.addEventListener('click', function (e) {
          var btn = e.target.closest('.renneway-chip');
          if (!btn) return;
          setChipSelected(numberChips, btn);
          selection.number = btn.getAttribute('data-value');
          if (actionStep) actionStep.hidden = !(selection.color && selection.number);
          emitSelectionChange();
        });
      }
    });
  }

  function setChipSelected(container, activeBtn) {
    container.querySelectorAll('.renneway-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', b === activeBtn ? 'true' : 'false');
    });
  }

  // --- Variant SKU map + title/SKU display ---

  function normKey(color, number) {
    return String(color == null ? '' : color).trim().toLowerCase() + '||' + String(number == null ? '' : number).trim().toLowerCase();
  }

  function buildVariantSkuMap() {
    variantSkuMap = {};
    optionIdx = { color: -1, number: -1 };
    if (!productData || !Array.isArray(productData.optionNames) || !Array.isArray(productData.variants)) return;
    // Shopify option adlarını case-insensitive ara
    productData.optionNames.forEach(function (n, idx) {
      var key = String(n || '').toLowerCase();
      if (key.indexOf('color') >= 0 || key.indexOf('renk') >= 0) optionIdx.color = idx;
      else if (key.indexOf('number') >= 0 || key.indexOf('numara') >= 0 || key.indexOf('count') >= 0 || key.indexOf('size') >= 0) optionIdx.number = idx;
    });
    productData.variants.forEach(function (v) {
      if (!v || !Array.isArray(v.options)) return;
      var c = optionIdx.color >= 0 ? v.options[optionIdx.color] : null;
      var n = optionIdx.number >= 0 ? v.options[optionIdx.number] : null;
      variantSkuMap[normKey(c, n)] = v.sku || '';
    });
  }

  function resolveSku(color, number) {
    // Hem renk hem numara seçili değilse SKU verme (deterministik olmayabilir)
    if (!color || !number) return '';
    return variantSkuMap[normKey(color, number)] || '';
  }

  function bindVariantDisplay() {
    window.addEventListener('renneway:selection-change', function (e) {
      var d = e.detail || {};
      // Title suffix güncelle — sadece bu ürün sayfasında, asıl main-product içinde
      var suffixNodes = document.querySelectorAll('[data-renneway-title-suffix]');
      var suffix = '';
      if (d.color) suffix += ' ' + d.color;
      if (d.number) suffix += ' ' + d.number;
      suffixNodes.forEach(function (el) {
        el.textContent = suffix;
      });
      // SKU display'i güncelle — boşsa gizle
      var skuNodes = document.querySelectorAll('[data-renneway-sku-display]');
      skuNodes.forEach(function (el) {
        if (d.sku) {
          el.textContent = 'SKU: ' + d.sku;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    });
  }

  function emitSelectionChange() {
    var sku = resolveSku(selection.color, selection.number);
    window.dispatchEvent(new CustomEvent('renneway:selection-change', {
      detail: { color: selection.color, number: selection.number, sku: sku }
    }));
  }

  // Renk -> Shopify featured media id haritasi.
  // Her renk icin o rengin gorseli olan ilk varyanttan media id alinir.
  function buildColorMediaMap() {
    colorMediaMap = {};
    if (!productData || !productData.variants || !productData.optionNames) return;
    var colorIdx = -1;
    productData.optionNames.forEach(function (name, i) {
      if (/^(color|colour|renk)$/i.test(String(name).trim())) colorIdx = i;
    });
    if (colorIdx < 0) return;
    productData.variants.forEach(function (v) {
      var color = v.options && v.options[colorIdx];
      if (color && v.featuredMediaId && !colorMediaMap[color]) {
        colorMediaMap[color] = v.featuredMediaId;
      }
    });
  }

  // Liquid product-json ILK 250 varyanti verir (Shopify siniri). 250+ varyantli
  // urunlerde (orn. woercp00/oercp00, 432 varyant) kalan varyantlar AJAX
  // /products/{handle}.js?page=N ile cekilir — yoksa Yellow-602 sonrasi renklerin
  // gorsel haritasi ve SKU/variant-id eslesmesi hic olusmaz.
  // Locale-prefix'li cagrilir ki option degerleri (Sarı-602 vb.) sayfadakiyle ayni dilde gelsin.
  function fetchRemainingVariants() {
    if (!productData || !productData.variants || productData.variants.length < 250) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var page = 2;
    function next() {
      fetch(root + 'products/' + encodeURIComponent(productData.handle) + '.js?page=' + page)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pj) {
          var vs = (pj && pj.variants) || [];
          if (!vs.length) return;
          vs.forEach(function (v) {
            productData.variants.push({
              id: v.id,
              title: v.title,
              sku: v.sku,
              options: v.options,
              available: v.available,
              featuredMediaId: v.featured_media ? v.featured_media.id : null
            });
          });
          buildColorMediaMap();
          buildVariantSkuMap();
          if (vs.length === 250) { page++; next(); }
        })
        .catch(function () {});
    }
    next();
  }

  // Renk secilince urun medya galerisini o rengin gorseline kaydirir.
  // Rengin ozel gorseli YOKSA hicbir sey yapilmaz — mevcut gorunum korunur
  // (slide-0 fallback'i kaldirildi: ilk slide her urunle alakasiz bir renk olabiliyor).
  function switchGalleryToColor(color) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery._selectSlide !== 'function') return;
    var mediaId = colorMediaMap[color];
    if (!mediaId) return;
    var slides = gallery.querySelectorAll('[data-media-id]');
    var suffix = '-' + mediaId;
    for (var i = 0; i < slides.length; i++) {
      var did = slides[i].getAttribute('data-media-id') || '';
      if (did.slice(-suffix.length) === suffix) {
        // Swiper loop modunda gercek index attribute'ta; loop degilse (attribute yok)
        // ayni listedeki data-media-id'li kardesler arasindaki DOM sirasi kullanilir.
        var idx = parseInt(slides[i].getAttribute('data-swiper-slide-index'), 10);
        if (isNaN(idx)) {
          var siblings = slides[i].parentElement
            ? slides[i].parentElement.querySelectorAll(':scope > [data-media-id]')
            : [];
          idx = Array.prototype.indexOf.call(siblings, slides[i]);
        }
        if (idx >= 0 && !isNaN(idx)) gallery._selectSlide(idx);
        return;
      }
    }
  }

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    loadOffers();
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    openOfferId = null;
  }

  function loadOffers() {
    if (!productData) {
      listEl.innerHTML = '<div class="renneway-error">' + window.rnwT('drawer.product_missing','Product data missing.') + '</div>';
      return;
    }
    var number = selection.number;
    var color = selection.color;
    if (!number || !color) {
      listEl.innerHTML = '<div class="renneway-empty">' + window.rnwT('drawer.select_first','Please select color and number first.') + '</div>';
      return;
    }

    subEl.textContent = [productData.handle, window.rnwT('drawer.color_label','Color')+': '+color, window.rnwT('drawer.number_label','Number')+': '+number].join(' · ');
    listEl.innerHTML = '<div class="renneway-loading">' + window.rnwT('offers.loading','Loading…') + '</div>';

    // Locale-stable Shopify variant.id'yi de gönder. Storefront TR ise renk/numara
    // degerleri cevrilmis olabilir ("Grey" -> "Gri") ama variant.id sabit.
    var selectedVariantId = '';
    if (productData.variants && productData.variants.length) {
      for (var vi = 0; vi < productData.variants.length; vi++) {
        var vv = productData.variants[vi];
        var opts = vv.options || [];
        if (opts.indexOf(number) !== -1 && opts.indexOf(color) !== -1) {
          selectedVariantId = String(vv.id || '');
          break;
        }
      }
    }

    var url = API_BASE + '/api/public/offers?handle=' + encodeURIComponent(productData.handle)
      + '&number=' + encodeURIComponent(number)
      + '&color=' + encodeURIComponent(color)
      + (selectedVariantId ? '&variantId=' + encodeURIComponent(selectedVariantId) : '');

    fetch(url, { headers: authHeaders({ 'Accept': 'application/json' }) })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          listEl.innerHTML = '<div class="renneway-error">' + escapeHtml(res.body.error || window.rnwT('drawer.error_generic','An error occurred')) + '</div>';
          return;
        }
        if (Array.isArray(res.body.paymentMethods)) paymentMethods = res.body.paymentMethods;
        renderOffers(res.body);
      })
      .catch(function (err) {
        listEl.innerHTML = '<div class="renneway-error">Connection error: ' + escapeHtml(err.message) + '</div>';
      });
  }

  function isTurkishUI() {
    var l = (window.RENNEWAY_I18N && window.RENNEWAY_I18N['common.lang']) || document.documentElement.lang || 'en';
    return String(l).toLowerCase().indexOf('tr') === 0;
  }

  var LOCK_TEXT = {
    guestTitle: { tr: 'Fiyatları görmek için üye olun', en: 'Sign up to see prices' },
    guestBody: { tr: 'Tedarikçi fiyatları yalnızca onaylı firmalara açıktır. Firmanızla ücretsiz başvurun, onaylandığında tüm fiyatları görün.', en: 'Supplier prices are available to verified companies only. Apply with your company for free and see every price once approved.' },
    pendingTitle: { tr: 'Hesabınız onay bekliyor', en: 'Your account is awaiting approval' },
    pendingBody: { tr: 'Başvurunuz ekibimizce inceleniyor. Onaylandığında e-postayla haber vereceğiz ve fiyatlar burada görünecek.', en: 'Our team is reviewing your application. We will email you once it is approved and prices will appear here.' },
    rejectedTitle: { tr: 'Hesabınız onaylanmadı', en: 'Your account was not approved' },
    rejectedBody: { tr: 'Detaylar için bize e-postayla ulaşabilirsiniz.', en: 'Please contact us by email for details.' },
    register: { tr: 'Firma olarak üye ol', en: 'Apply as a company' },
    signIn: { tr: 'Giriş yap', en: 'Sign in' },
    suppliers: { tr: 'Bu ürünü sunan tedarikçiler', en: 'Suppliers offering this product' },
    noSuppliers: { tr: 'Bu ürün için henüz tedarikçi teklifi yok.', en: 'No supplier offers for this product yet.' },
    priceHidden: { tr: 'Fiyat üyelere özel', en: 'Price for members' },
    supplierTitle: { tr: 'Tedarikçi hesabıyla görüntülüyorsunuz', en: 'You are viewing as a supplier' },
    supplierBody: { tr: 'Yalnızca kendi teklifinizin fiyatını görürsünüz. Diğer tedarikçilerin fiyatları gizlidir ve tedarikçi hesabıyla sipariş verilemez.', en: 'You only see the price of your own offer. Other suppliers\' prices are hidden and orders cannot be placed from a supplier account.' },
    supplierNoOwn: { tr: 'Bu varyant için teklifiniz yok.', en: 'You have no offer for this variant.' },
    noPaymentMethod: { tr: 'Bu tedarikçi henüz havale bilgilerini eklemedi; şu anda bu tedarikçiden sipariş verilemiyor. Teklif almak için pazarlık veya numune talebi gönderebilirsiniz.', en: 'This supplier has not added bank transfer details yet, so orders cannot be placed right now. You can still send a counter offer or a sample request.' },
    otherSuppliers: { tr: 'Diğer tedarikçiler', en: 'Other suppliers' }
  };
  function lt(k) { return LOCK_TEXT[k][isTurkishUI() ? 'tr' : 'en']; }

  function renderLockedOffers(offers, access) {
    var title = access === 'rejected' ? lt('rejectedTitle') : access === 'pending' ? lt('pendingTitle') : lt('guestTitle');
    var body = access === 'rejected' ? lt('rejectedBody') : access === 'pending' ? lt('pendingBody') : lt('guestBody');
    var actions = access === 'guest'
      ? '<div class="rnw-lock__actions">' +
          '<button type="button" class="rnw-lock__btn rnw-lock__btn--primary" data-rnw-lock-register>' + escapeHtml(lt('register')) + '</button>' +
          '<button type="button" class="rnw-lock__btn" data-rnw-lock-login>' + escapeHtml(lt('signIn')) + '</button>' +
        '</div>'
      : '';

    var rows = offers.length
      ? offers.map(function (o) {
          return '<button type="button" class="rnw-lock__row" data-rnw-lock-row>' +
            '<span class="rnw-lock__name">' + escapeHtml(o.supplier && o.supplier.name) + '</span>' +
            '<span class="rnw-lock__price"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>' +
            escapeHtml(lt('priceHidden')) + '</span>' +
          '</button>';
        }).join('')
      : '<div class="rnw-lock__empty">' + escapeHtml(lt('noSuppliers')) + '</div>';

    listEl.innerHTML =
      '<div class="rnw-lock rnw-lock--' + access + '">' +
        '<div class="rnw-lock__head">' +
          '<div class="rnw-lock__title">' + escapeHtml(title) + '</div>' +
          '<p class="rnw-lock__body">' + escapeHtml(body) + '</p>' +
          actions +
        '</div>' +
        (offers.length ? '<div class="rnw-lock__label">' + escapeHtml(lt('suppliers')) + '</div>' : '') +
        '<div class="rnw-lock__list">' + rows + '</div>' +
      '</div>';

    var reg = listEl.querySelector('[data-rnw-lock-register]');
    if (reg) reg.addEventListener('click', function () { onAuthSuccess = loadOffers; openAuthModal('register'); });
    var login = listEl.querySelector('[data-rnw-lock-login]');
    if (login) login.addEventListener('click', function () { onAuthSuccess = loadOffers; openAuthModal('login'); });
    listEl.querySelectorAll('[data-rnw-lock-row]').forEach(function (row) {
      row.addEventListener('click', function () {
        if (access === 'guest') { onAuthSuccess = loadOffers; openAuthModal('register'); return; }
        var head = listEl.querySelector('.rnw-lock__head');
        if (head) { head.classList.remove('is-pulse'); void head.offsetWidth; head.classList.add('is-pulse'); }
      });
    });
  }

  function renderOffers(data) {
    var offers = data.offers || [];
    // /api/public/offers cevabındaki variant.sku ile lokal map'i güncelle (safety net)
    if (data.variant && data.variant.sku && selection.color && selection.number) {
      var key = normKey(selection.color, selection.number);
      if (variantSkuMap[key] !== data.variant.sku) {
        variantSkuMap[key] = data.variant.sku;
        emitSelectionChange();
      }
    }
    // Tedarikci hesabi: yalnizca kendi teklifinin fiyatini gorur, siparis veremez; digerleri kilitli
    var supplierView = data.priceAccess === 'supplier';
    listEl.classList.toggle('is-supplier-view', supplierView);

    // Fiyatlar yalnizca admin onayli alicilara acik — digerleri tedarikci adlarini gorur
    if (data.priceAccess && data.priceAccess !== 'approved' && !supplierView) {
      renderLockedOffers(offers, data.priceAccess);
      return;
    }

    if (offers.length === 0) {
      if (supplierView) { listEl.innerHTML = '<div class="renneway-empty">' + escapeHtml(lt('noSuppliers')) + '</div>'; return; }
      renderRfqForm();
      return;
    }

    if (supplierView) {
      var ownOffers = offers.filter(function (o) { return !o.locked; });
      var otherOffers = offers.filter(function (o) { return o.locked; });
      listEl.innerHTML =
        '<div class="rnw-lock rnw-lock--supplier"><div class="rnw-lock__head">' +
          '<div class="rnw-lock__title">' + escapeHtml(lt('supplierTitle')) + '</div>' +
          '<p class="rnw-lock__body">' + escapeHtml(lt('supplierBody')) + '</p>' +
        '</div></div>' +
        (ownOffers.length
          ? ownOffers.map(function (o) { return renderOffer(o, data.variant); }).join('')
          : '<div class="renneway-empty">' + escapeHtml(lt('supplierNoOwn')) + '</div>') +
        (otherOffers.length
          ? '<div class="rnw-lock"><div class="rnw-lock__label">' + escapeHtml(lt('otherSuppliers')) + '</div><div class="rnw-lock__list">' +
              otherOffers.map(function (o) {
                return '<div class="rnw-lock__row"><span class="rnw-lock__name">' + escapeHtml(o.supplier && o.supplier.name) + '</span>' +
                  '<span class="rnw-lock__price">' + escapeHtml(lt('priceHidden')) + '</span></div>';
              }).join('') +
            '</div></div>'
          : '');
    } else {
      listEl.innerHTML = offers.map(function (o) { return renderOffer(o, data.variant); }).join('');
    }

    listEl.querySelectorAll('.renneway-offer__summary').forEach(function (el) {
      el.addEventListener('click', function () {
        var offerEl = el.closest('.renneway-offer');
        var id = offerEl.getAttribute('data-offer-id');
        document.querySelectorAll('.renneway-offer.is-open').forEach(function (x) {
          if (x !== offerEl) x.classList.remove('is-open');
        });
        offerEl.classList.toggle('is-open');
        openOfferId = offerEl.classList.contains('is-open') ? id : null;
      });
    });

    listEl.querySelectorAll('.renneway-offer').forEach(function (offerEl) {
      var kgInput = offerEl.querySelector('.rnw-kg-input');
      if (kgInput) kgInput.addEventListener('input', function () { recalc(offerEl); });

      var freightPort = offerEl.querySelector('[data-rnw-freight-port]');
      if (freightPort) freightPort.addEventListener('change', function () { recalcFreight(offerEl); });

      // Origin selection — kullanici tikladiginda step 2 ve step 3 acilir
      offerEl.querySelectorAll('.rnw-origin-opt').forEach(function (btn) {
        btn.addEventListener('click', function () { selectOrigin(offerEl, btn); });
      });

      var orderBtn = offerEl.querySelector('.rnw-order-btn');
      if (orderBtn) orderBtn.addEventListener('click', function () {
        if (orderBtn.disabled) return;
        openOrderPane(offerEl);
      });

      var cartBtn = offerEl.querySelector('.rnw-cart-add-btn');
      if (cartBtn) cartBtn.addEventListener('click', function () {
        if (cartBtn.disabled || !window.rnwCart) return;
        addOfferToCart(offerEl, cartBtn);
      });

      var negSubmit = offerEl.querySelector('[data-rnw-negotiate-submit]');
      if (negSubmit) negSubmit.addEventListener('click', function () { submitNegotiation(offerEl); });
      bindNegotiateUx(offerEl);

      // Numune talebi — buton + inline mini form
      var sampleBtn = offerEl.querySelector('[data-rnw-sample-btn]');
      if (sampleBtn) sampleBtn.addEventListener('click', function () { toggleSampleForm(offerEl); });
      var sampleSend = offerEl.querySelector('[data-rnw-sample-send]');
      if (sampleSend) sampleSend.addEventListener('click', function () { submitSampleRequest(offerEl); });
      var sampleCancel = offerEl.querySelector('[data-rnw-sample-cancel]');
      if (sampleCancel) sampleCancel.addEventListener('click', function () { toggleSampleForm(offerEl, true); });

      offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
        certEl.querySelectorAll('.rnw-cert__opt').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var pct = parseInt(btn.getAttribute('data-pct'), 10);
            certEl.querySelectorAll('.rnw-cert__opt').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            setCertState(certEl, pct);
            refreshCertLimits(offerEl);
            recalc(offerEl);
          });
        });
      });

      refreshCertLimits(offerEl);
    });

    // Tek tedarikci varsa kart otomatik acilsin (50+ kullanici icin ekstra adim engellemek icin)
    if (offers.length === 1) {
      var sole = listEl.querySelector('.renneway-offer');
      if (sole && !sole.classList.contains('is-open')) {
        sole.classList.add('is-open');
        openOfferId = sole.getAttribute('data-offer-id');
      }
    }
  }

  function selectOrigin(offerEl, btn) {
    offerEl.querySelectorAll('.rnw-origin-opt').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    var min = parseFloat(btn.getAttribute('data-min')) || 0;
    var stock = parseFloat(btn.getAttribute('data-stock')) || 0;
    var lead = parseInt(btn.getAttribute('data-lead'), 10) || 0;
    var price = parseFloat(btn.getAttribute('data-price')) || 0;
    var name = btn.getAttribute('data-name') || '';
    var flag = btn.getAttribute('data-flag') || '';

    var promptEl = offerEl.querySelector('[data-origin-prompt]');
    if (promptEl) promptEl.hidden = true;

    var metaEl = offerEl.querySelector('[data-origin-meta]');
    if (metaEl) {
      metaEl.hidden = false;
      metaEl.innerHTML =
        '<div class="rnw-origin-meta__row"><span>' + window.rnwT('drawer.selected_country','Selected country') + '</span><strong>' + flag + ' ' + escapeHtml(name) + '</strong></div>' +
        '<div class="rnw-origin-meta__row"><span>' + window.rnwT('drawer.lead_time','Lead time') + '</span><strong>' + lead + ' ' + window.rnwT('drawer.days','days') + '</strong></div>';
    }

    var qtyWrap = offerEl.querySelector('[data-qty-wrap]');
    if (qtyWrap) qtyWrap.hidden = false;

    var certsWrap = offerEl.querySelector('[data-certs-wrap]');
    if (certsWrap) certsWrap.hidden = false;

    var kgInput = offerEl.querySelector('.rnw-kg-input');
    if (kgInput) {
      kgInput.min = Math.max(min, 1);
      if (!kgInput.value || parseFloat(kgInput.value) < min) {
        kgInput.value = Math.max(min, 1);
      }
    }
    var hintEl = offerEl.querySelector('[data-kg-hint]');
    if (hintEl) hintEl.textContent = window.rnwTfmt('drawer.min_stock_hint','Minimum {min} kg · {stock} kg available in stock',{min:min,stock:stock});

    renderQtyQuick(offerEl, min, stock);

    var orderHint = offerEl.querySelector('[data-order-hint]');
    if (orderHint) orderHint.textContent = window.rnwT('drawer.adjust_qty','Adjust quantity below, then continue');

    // Negotiate paneli artık göster (origin + min stock + price hazır)
    var negEl = offerEl.querySelector('[data-rnw-negotiate]');
    if (negEl) negEl.hidden = false;

    recalc(offerEl);
  }

  function renderQtyQuick(offerEl, min, stock) {
    var wrap = offerEl.querySelector('[data-kg-quick]');
    if (!wrap) return;
    var picks = [];
    picks.push({ label: 'Minimum (' + min + ' kg)', value: min });
    var two = min * 2; if (two <= stock) picks.push({ label: two + ' kg', value: two });
    var four = min * 4; if (four <= stock) picks.push({ label: four + ' kg', value: four });
    var ten = min * 10; if (ten <= stock) picks.push({ label: ten + ' kg', value: ten });
    wrap.innerHTML = picks.map(function (p) {
      return '<button type="button" class="rnw-kg-quick__btn" data-kg-pick="' + p.value + '">' + escapeHtml(p.label) + '</button>';
    }).join('');
    wrap.querySelectorAll('[data-kg-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseFloat(btn.getAttribute('data-kg-pick'));
        var kgInput = offerEl.querySelector('.rnw-kg-input');
        if (kgInput) kgInput.value = val;
        wrap.querySelectorAll('[data-kg-pick]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        recalc(offerEl);
      });
    });
  }

  function setCertState(certEl, pct) {
    certEl.setAttribute('data-cert-state', String(pct));
    var display = certEl.querySelector('.rnw-cert__value');
    if (display) display.textContent = pct + '%';
  }

  function otherCertsTotal(offerEl, skipCertEl) {
    var total = 0;
    offerEl.querySelectorAll('.rnw-cert').forEach(function (el) {
      if (el === skipCertEl) return;
      total += parseInt(el.getAttribute('data-cert-state'), 10) || 0;
    });
    return total;
  }

  function refreshCertLimits(offerEl) {
    offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
      var otherSum = otherCertsTotal(offerEl, certEl);
      var remaining = 100 - otherSum;
      var curState = parseInt(certEl.getAttribute('data-cert-state'), 10) || 0;
      certEl.querySelectorAll('.rnw-cert__opt').forEach(function (btn) {
        var pct = parseInt(btn.getAttribute('data-pct'), 10);
        var overBudget = pct > remaining && pct !== curState;
        btn.disabled = overBudget;
        btn.classList.toggle('is-disabled', overBudget);
        if (overBudget) {
          var msg = window.rnwTfmt('drawer.cert_left_warn','Other certificates already use {used}%. Only {left}% left.',{used:otherSum,left:remaining});
          btn.setAttribute('data-tooltip', msg);
          btn.setAttribute('title', msg);
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('data-tooltip');
          btn.removeAttribute('title');
          btn.removeAttribute('aria-disabled');
        }
      });
    });
  }

  function renderOffer(o, variant) {
    var logo = o.supplier.logoUrl ?
      '<img class="renneway-offer__logo" src="' + escapeAttr(absoluteUrl(o.supplier.logoUrl)) + '" alt="">' :
      '<div class="renneway-offer__logo renneway-offer__logo--placeholder">' +
        escapeHtml(o.supplier.name.slice(0, 2).toUpperCase()) +
      '</div>';

    var qualityImg = o.qualityImageUrl
      ? '<div class="renneway-offer__quality-title">' + window.rnwT('drawer.quality_report','Yarn quality report') + '</div>' +
        '<a class="rnw-quality-img-link" href="' + escapeAttr(absoluteUrl(o.qualityImageUrl)) + '" target="_blank" rel="noopener" title="' + window.rnwT('drawer.open_full','Open full size') + '">' +
          '<img class="rnw-quality-img" src="' + escapeAttr(absoluteUrl(o.qualityImageUrl)) + '" alt="' + window.rnwT('drawer.quality_alt','Yarn quality test report') + '" loading="lazy">' +
        '</a>'
      : '';

    var certs = (o.certificates || []).map(function (c) {
      var tiers = (c.tiers || []).slice().sort(function (a, b) { return a.percent - b.percent; });
      var tierByPct = {};
      tiers.forEach(function (t) { tierByPct[t.percent] = t.pricePerKg; });
      var cls = tiers.length > 1 ? 'rnw-cert--steps' : 'rnw-cert--binary';
      var cols = tiers.length + 1; // +1 for 0% button

      // Build tier buttons: 0% first (free), then each defined tier
      var optsHtml = '<button type="button" class="rnw-cert__opt is-active" data-pct="0" data-price="0">0%</button>';
      optsHtml += tiers.map(function (t) {
        return '<button type="button" class="rnw-cert__opt" data-pct="' + t.percent + '" data-price="' + t.pricePerKg + '">' +
                 t.percent + '%<span class="rnw-cert__tier-price"> · +$' + t.pricePerKg.toFixed(2) + '/kg</span>' +
               '</button>';
      }).join('');

      var logoHtml = c.logoUrl
        ? '<img class="rnw-cert__logo" src="' + escapeAttr(absoluteUrl(c.logoUrl)) + '" alt="">'
        : '';
      var descHtml = c.shortDescription
        ? '<div class="rnw-cert__desc">' + escapeHtml(c.shortDescription) + '</div>'
        : '';
      var linkHtml = c.officialUrl
        ? ' · <a class="rnw-cert__link" href="' + escapeAttr(c.officialUrl) + '" target="_blank" rel="noopener">learn more</a>'
        : '';

      return (
        '<div class="rnw-cert ' + cls + '" data-cert-id="' + escapeAttr(c.id) + '" data-cert-state="0" data-tier-cols="' + cols + '" data-selectable="' + (c.selectablePercentage ? '1' : '0') + '">' +
          '<div class="rnw-cert__head">' +
            logoHtml +
            '<div class="rnw-cert__info">' +
              '<div class="rnw-cert__name">' + escapeHtml(c.name) + '</div>' +
              '<div class="rnw-cert__price">' + tiers.length + ' tier(s) available' + linkHtml + '</div>' +
              descHtml +
            '</div>' +
            '<div class="rnw-cert__value">0%</div>' +
          '</div>' +
          '<div class="rnw-cert__steps-wrap" style="grid-template-columns:repeat(' + cols + ',1fr)">' + optsHtml + '</div>' +
        '</div>'
      );
    }).join('');

    var totalId = 'rnw-total-' + o.id;

    var origins = o.origins || [];
    var minPrice = origins.length ? Math.min.apply(null, origins.map(function (or) { return or.pricePerKg; })) : 0;
    // Üst başlıkta gösterilecek minimum origin'in compareAt'i
    var minPriceOrigin = origins.length ? origins.reduce(function (a, b) {
      return (a.pricePerKg <= b.pricePerKg) ? a : b;
    }) : null;
    var headerCompareAt = (minPriceOrigin && minPriceOrigin.campaignActive && minPriceOrigin.compareAtPricePerKg)
      ? minPriceOrigin.compareAtPricePerKg : null;
    var offerHasCampaign = origins.some(function (or) { return or.campaignActive; });

    var originOptsHtml = origins.map(function (or) {
      var hasCamp = or.campaignActive && or.compareAtPricePerKg > or.pricePerKg;
      var priceCell = hasCamp
        ? '<span class="rnw-origin-price">' +
            '<s class="rnw-origin-compare">$' + or.compareAtPricePerKg.toFixed(2) + '</s> ' +
            '<strong>$' + or.pricePerKg.toFixed(2) + '</strong>/kg' +
          '</span>'
        : '<span class="rnw-origin-price">$' + or.pricePerKg.toFixed(2) + '/kg</span>';
      var _origBadge = (window.rnwCampaign ? window.rnwCampaign(or.campaignBadge || 'SALE') : (or.campaignBadge || 'SALE'));
      var badgeRow = hasCamp
        ? '<div class="rnw-origin-line0"><span class="rnw-origin-campaign-badge">' + escapeHtml(_origBadge) + '</span></div>'
        : '';
      // Locale-aware origin name: TR locale ise nameTR, EN ise nameEN (backend her ikisini de doner).
      var _isTR = (window.RENNEWAY_I18N && window.RENNEWAY_I18N.locale === 'tr') || /^\/tr(\/|$)/.test(window.location.pathname);
      var _displayName = _isTR ? (or.nameTR || or.name) : (or.nameEN || or.name);
      return (
        '<button type="button" class="rnw-origin-opt' + (hasCamp ? ' is-campaign' : '') + '" ' +
          'data-origin-id="' + escapeAttr(or.originId) + '" ' +
          'data-name="' + escapeAttr(_displayName) + '" ' +
          'data-flag="' + escapeAttr(or.flagEmoji || '') + '" ' +
          'data-price="' + or.pricePerKg + '" ' +
          'data-compare-at="' + (hasCamp ? or.compareAtPricePerKg : '') + '" ' +
          'data-campaign-active="' + (hasCamp ? '1' : '0') + '" ' +
          'data-campaign-badge="' + escapeAttr(or.campaignBadge || '') + '" ' +
          'data-stock="' + or.stockKg + '" ' +
          'data-min="' + or.minOrderKg + '" ' +
          'data-lead="' + or.leadTimeDays + '">' +
          badgeRow +
          '<div class="rnw-origin-line1">' +
            '<span class="rnw-origin-flag">' + escapeHtml(or.flagEmoji || '🏳️') + '</span>' +
            '<span class="rnw-origin-name">' + escapeHtml(_displayName) + '</span>' +
            (or.incoterm ? '<span class="rnw-origin-incoterm">' + escapeHtml(or.incoterm) + '</span>' : '') +
            priceCell +
          '</div>' +
          '<div class="rnw-origin-line2">' +
            window.rnwTfmt('drawer.stock_line','{stock} kg in stock · min order {min} kg · ready in {lead} days',{stock:or.stockKg,min:or.minOrderKg,lead:or.leadTimeDays}) +
          '</div>' +
        '</button>'
      );
    }).join('');

    return (
      '<div class="renneway-offer" data-offer-id="' + escapeAttr(o.id) + '" data-accepts-bank="' + (o.supplier && o.supplier.acceptsBankTransfer ? '1' : '0') + '"' +
        (o.supplier && o.supplier.loadingPort ? ' data-loading-port="' + escapeAttr(o.supplier.loadingPort.locode) + '"' : '') + '>' +
        '<div class="renneway-offer__summary">' +
          logo +
          '<div class="renneway-offer__info">' +
            '<p class="renneway-offer__name">' + escapeHtml(o.supplier.name) + '</p>' +
            '<p class="renneway-offer__meta">' +
              (o.supplier.city ? escapeHtml(o.supplier.city) + ' · ' : '') +
              origins.length + ' ' + window.rnwT(origins.length > 1 ? 'drawer.origins_available' : 'drawer.origin_available', origins.length > 1 ? 'origins available' : 'origin available') +
            '</p>' +
          '</div>' +
          '<div class="renneway-offer__price">' +
            (headerCompareAt ? '<s class="renneway-offer__compare">$' + headerCompareAt.toFixed(2) + '</s> ' : '') +
            (origins.length > 1 ? 'from $' : '$') + minPrice.toFixed(2) +
            '<small>/ kg</small>' +
            (offerHasCampaign ? '<span class="renneway-offer__campaign-badge">' + escapeHtml((window.rnwCampaign ? window.rnwCampaign((minPriceOrigin && minPriceOrigin.campaignBadge) || 'SALE') : ((minPriceOrigin && minPriceOrigin.campaignBadge) || 'SALE'))) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<div class="renneway-offer__detail">' +
          (function(){
            // TR locale'de backend offline ceviri (shortDescriptionTR) varsa onu kullan
            var isTR = (window.RENNEWAY_I18N && window.RENNEWAY_I18N.locale === 'tr') || /^\/tr(\/|$)/.test(window.location.pathname);
            var desc = (isTR && o.supplier.shortDescriptionTR) ? o.supplier.shortDescriptionTR : o.supplier.shortDescription;
            return desc ? '<p class="renneway-offer__desc">' + escapeHtml(desc) + '</p>' : '';
          })() +
          (o.supplier.website ? '<a class="renneway-offer__website" href="' + escapeAttr(o.supplier.website) + '" target="_blank" rel="noopener">' + window.rnwT('drawer.visit_website','Visit website →') + '</a>' : '') +
          // Numune talebi — tedarikci bazli buton + inline mini form (login sart)
          '<div class="rnw-sample-wrap" data-offer-id-sample="' + escapeAttr(o.id) + '">' +
            '<button type="button" class="rnw-sample-btn" data-rnw-sample-btn>🧵 ' + window.rnwT('drawer.sample_request','Request Sample') + '</button>' +
            '<div class="rnw-sample-form" data-rnw-sample-form hidden>' +
              '<label class="rnw-sample-label">' + window.rnwT('drawer.sample_addr_label','Delivery address') + '</label>' +
              '<textarea class="rnw-sample-addr" rows="2" maxlength="300" placeholder="' + escapeAttr(window.rnwT('drawer.sample_addr_ph','Street, building, district…')) + '"></textarea>' +
              '<input type="text" class="rnw-sample-note" maxlength="1000" placeholder="' + escapeAttr(window.rnwT('drawer.sample_note_ph','Note to supplier (optional)')) + '">' +
              '<div class="rnw-sample-actions">' +
                '<button type="button" class="rnw-sample-send" data-rnw-sample-send>' + window.rnwT('drawer.sample_send_btn','Send request') + '</button>' +
                '<button type="button" class="rnw-sample-cancel" data-rnw-sample-cancel>' + window.rnwT('drawer.sample_cancel_btn','Cancel') + '</button>' +
              '</div>' +
              '<div class="rnw-sample-msg" data-rnw-sample-msg hidden></div>' +
            '</div>' +
          '</div>' +
          qualityImg +
          '<div class="rnw-origins-wrap">' +
            '<div class="rnw-step-label"><span class="rnw-step-num">1</span> ' + window.rnwT('drawer.where_from_step','Where do you want it from?') + '</div>' +
            '<div class="rnw-origins">' + originOptsHtml + '</div>' +
            '<div class="rnw-origin-prompt" data-origin-prompt>' + window.rnwT('drawer.tap_country','Tap one of the countries above to continue.') + '</div>' +
            '<div class="rnw-origin-meta" data-origin-meta hidden></div>' +
          '</div>' +
          '<div class="rnw-qty-wrap" data-qty-wrap hidden>' +
            '<div class="rnw-step-label"><span class="rnw-step-num">2</span> ' + window.rnwT('drawer.how_much','How much do you need?') + '</div>' +
            '<div class="rnw-kg-quick" data-kg-quick></div>' +
            '<label class="rnw-field">' +
              '<span class="rnw-field__label">' + window.rnwT('drawer.quantity_in_kg','Quantity in kilograms') + '</span>' +
              '<input type="number" class="rnw-field__input rnw-kg-input" step="1" placeholder="' + window.rnwT('drawer.enter_amount','Enter amount') + '">' +
              '<span class="rnw-field__hint" data-kg-hint></span>' +
            '</label>' +
          '</div>' +
          (certs ?
            '<div class="rnw-certs" data-certs-wrap hidden>' +
              '<div class="rnw-step-label"><span class="rnw-step-num">3</span> Certificates <span class="rnw-step-optional">(optional — skip if not needed)</span></div>' +
              certs +
            '</div>' : '') +
          '<div class="rnw-total" id="' + totalId + '"></div>' +
          (o.supplier && o.supplier.loadingPort
            ? '<div class="rnw-freight" data-rnw-freight hidden>' +
                '<div class="rnw-freight__head">' +
                  '<span class="rnw-freight__title">' + window.rnwT('drawer.freight_title', 'Estimated sea freight') + '</span>' +
                  '<span class="rnw-freight__from">' + window.rnwT('drawer.freight_from_port', 'from') + ' ' +
                    escapeHtml(o.supplier.loadingPort.name || o.supplier.loadingPort.locode) + '</span>' +
                '</div>' +
                '<select class="rnw-freight__port" data-rnw-freight-port>' +
                  '<option value="">' + window.rnwT('drawer.freight_select_port', 'Select destination port') + '</option>' +
                '</select>' +
                '<div class="rnw-freight__result" data-rnw-freight-result></div>' +
              '</div>'
            : '') +
          '<div class="rnw-buy-actions">' +
            '<button type="button" class="rnw-cart-add-btn" disabled>' + escapeHtml(window.rnwCart ? window.rnwCart.t('addToCart') : 'Add to cart') + '</button>' +
            '<button type="button" class="rnw-order-btn" disabled>' + window.rnwT('drawer.continue_to_details','Continue to your details →') + '</button>' +
          '</div>' +
          '<div class="rnw-order-btn__hint" data-order-hint>' + window.rnwT('drawer.first_choose_country','First, choose a country above') + '</div>' +
          '<details class="rnw-negotiate" data-rnw-negotiate hidden>' +
            '<summary class="rnw-negotiate__summary">' + window.rnwT('drawer.want_better_price','Want a better price? Send a counter offer →') + '</summary>' +
            '<div class="rnw-negotiate__body" data-rnw-negotiate-body>' +
              '<p class="rnw-negotiate__help">' + window.rnwT('drawer.negotiate_help','Enter the total amount you would pay (certificates included). Yarn price per kg is calculated automatically based on your selected certificates.') + '</p>' +
              '<label class="rnw-field">' +
                '<span class="rnw-field__label">' + window.rnwT('drawer.your_total_offer','Your total offer ($) — incl. certificates') + '</span>' +
                '<input type="number" step="0.01" min="0" data-rnw-negotiate-total placeholder="e.g. 1250.00">' +
              '</label>' +
              '<div class="rnw-negotiate__breakdown" data-rnw-negotiate-breakdown></div>' +
              '<label class="rnw-field">' +
                '<span class="rnw-field__label">' + window.rnwT('drawer.message_opt','Message (optional)') + '</span>' +
                '<textarea rows="2" maxlength="2000" data-rnw-negotiate-message placeholder="' + window.rnwT('drawer.negotiate_msg_ph','Any context for the supplier...') + '"></textarea>' +
              '</label>' +
              '<button type="button" class="rnw-negotiate__submit" data-rnw-negotiate-submit>' + window.rnwT('drawer.send_offer','Send offer') + '</button>' +
              '<div class="rnw-negotiate__msg" data-rnw-negotiate-msg hidden></div>' +
            '</div>' +
          '</details>' +
        '</div>' +
      '</div>'
    );
  }

  // ---- Navlun tahmini (Hapag Prices API) ----
  // Tedarikcinin yukleme limani tanimliysa cekmecede varis limani secilebilir;
  // miktar girilince konteyner fiyatindan kilo basina pay hesaplanip gosterilir.

  var freightPortsPromise = null;

  function loadFreightPorts() {
    if (!freightPortsPromise) {
      freightPortsPromise = fetch(API_BASE + '/api/public/ports', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { return (j && j.ports) || []; })
        .catch(function () { return []; });
    }
    return freightPortsPromise;
  }

  function fillFreightPorts(offerEl) {
    var sel = offerEl.querySelector('[data-rnw-freight-port]');
    if (!sel || sel.getAttribute('data-filled')) return;
    sel.setAttribute('data-filled', '1');
    var isTR = (window.rnwLang && window.rnwLang() === 'tr') ||
      (window.RENNEWAY_I18N && String(window.RENNEWAY_I18N['common.lang'] || '').toLowerCase().indexOf('tr') === 0);
    loadFreightPorts().then(function (ports) {
      var loading = offerEl.getAttribute('data-loading-port') || '';
      ports.forEach(function (p) {
        if (p.code === loading) return;
        var opt = document.createElement('option');
        opt.value = p.code;
        opt.textContent = isTR ? p.tr : p.en;
        sel.appendChild(opt);
      });
    });
  }

  function recalcFreight(offerEl) {
    var wrap = offerEl.querySelector('[data-rnw-freight]');
    if (!wrap) return;
    var sel = offerEl.querySelector('[data-rnw-freight-port]');
    var box = offerEl.querySelector('[data-rnw-freight-result]');
    var kg = parseFloat(offerEl.querySelector('.rnw-kg-input').value);
    var from = offerEl.getAttribute('data-loading-port');
    var to = sel ? sel.value : '';

    if (!kg || kg <= 0) { wrap.hidden = true; return; }
    wrap.hidden = false;
    fillFreightPorts(offerEl);
    if (!to || !from) { box.innerHTML = ''; return; }

    box.innerHTML = '<div class="rnw-freight__msg">' + window.rnwT('drawer.freight_loading', 'Calculating freight…') + '</div>';

    var token = 'f' + Date.now();
    wrap.setAttribute('data-req', token);

    fetch(API_BASE + '/api/public/freight-estimate?from=' + encodeURIComponent(from) +
          '&to=' + encodeURIComponent(to) + '&kg=' + encodeURIComponent(kg),
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (wrap.getAttribute('data-req') !== token) return;
        if (!j || !j.ok || !j.estimate) {
          box.innerHTML = '<div class="rnw-freight__msg">' + window.rnwT('drawer.freight_error', 'Freight estimate unavailable') + '</div>';
          return;
        }
        var e = j.estimate;
        var extra = [];
        if (e.transitTime != null) {
          extra.push(e.transitTime + ' ' + window.rnwT('drawer.freight_days', 'days') + ' ' + window.rnwT('drawer.freight_transit', 'transit'));
        }
        box.innerHTML =
          '<div class="rnw-freight__row">' +
            '<span>' + window.rnwT('drawer.freight_line', 'Sea freight') + ' (' + kg + ' kg)' +
              (extra.length ? ' <span class="rnw-freight__meta">· ' + escapeHtml(extra.join(' · ')) + '</span>' : '') +
            '</span>' +
            '<strong>$' + e.totalUsd.toFixed(2) + '</strong>' +
          '</div>' +
          (e.isPartialLoad
            ? '<div class="rnw-freight__note">' + window.rnwT('drawer.freight_partial', 'Container price share — actual groupage freight may differ') + '</div>'
            : '');
      })
      .catch(function () {
        if (wrap.getAttribute('data-req') !== token) return;
        box.innerHTML = '<div class="rnw-freight__msg">' + window.rnwT('drawer.freight_error', 'Freight estimate unavailable') + '</div>';
      });
  }

  function recalc(offerEl) {
    recalcFreight(offerEl);
    var offerId = offerEl.getAttribute('data-offer-id');
    var kg = parseFloat(offerEl.querySelector('.rnw-kg-input').value);
    var activeOriginBtn = offerEl.querySelector('.rnw-origin-opt.is-active');
    var originId = activeOriginBtn ? activeOriginBtn.getAttribute('data-origin-id') : null;
    var certificates = [];
    offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
      var pct = parseInt(certEl.getAttribute('data-cert-state'), 10) || 0;
      if (pct > 0) {
        certificates.push({ id: certEl.getAttribute('data-cert-id'), percent: pct });
      }
    });
    var totalEl = offerEl.querySelector('.rnw-total');
    var hintEl = offerEl.querySelector('[data-order-hint]');

    if (!originId) {
      totalEl.innerHTML = '';
      setBuyEnabled(offerEl, false);
      if (hintEl) { hintEl.textContent = window.rnwT('drawer.first_choose_country','First, choose a country above'); hintEl.hidden = false; }
      return;
    }
    if (!kg || kg <= 0) {
      totalEl.innerHTML = '';
      setBuyEnabled(offerEl, false);
      if (hintEl) { hintEl.textContent = window.rnwT('drawer.enter_qty','Enter the quantity you need'); hintEl.hidden = false; }
      return;
    }

    fetch(API_BASE + '/api/public/calculate-price', {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ offerId: offerId, originId: originId, kg: kg, certificates: certificates })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          totalEl.innerHTML = '<div class="rnw-total__err">' + escapeHtml(res.body.error || 'Error') + '</div>';
          setBuyEnabled(offerEl, false);
          if (hintEl) { hintEl.textContent = res.body.error || ''; hintEl.hidden = false; }
          return;
        }
        var b = res.body.breakdown;
        var yarnLine;
        if (b.compareAt) {
          yarnLine = '<div class="rnw-total__row rnw-total__row--campaign">' +
            '<span>' + window.rnwT('drawer.yarn_qty_label','Yarn') + ' (' + b.yarn.kg + ' kg × <s>$' + b.compareAt.pricePerKg.toFixed(2) + '</s> $' + b.yarn.pricePerKg.toFixed(2) + ')' +
            '<span class="rnw-total__badge">' + escapeHtml(window.rnwCampaign ? window.rnwCampaign(b.compareAt.badge || 'SALE') : (b.compareAt.badge || 'SALE')) + '</span>' +
            '</span>' +
            '<strong><s>$' + b.compareAt.yarnAmount.toFixed(2) + '</s> $' + b.yarn.amount.toFixed(2) + '</strong>' +
          '</div>';
        } else {
          yarnLine = '<div class="rnw-total__row"><span>' + window.rnwT('drawer.yarn_qty_label','Yarn') + ' (' + b.yarn.kg + ' kg × $' + b.yarn.pricePerKg.toFixed(2) + ')</span><strong>$' + b.yarn.amount.toFixed(2) + '</strong></div>';
        }
        var html = yarnLine;
        b.certificates.forEach(function (c) {
          html += '<div class="rnw-total__row"><span>' + escapeHtml(c.name) + ' (' + c.percent + '% × $' + c.pricePerKg.toFixed(2) + ')</span><strong>$' + c.amount.toFixed(2) + '</strong></div>';
        });
        html += '<div class="rnw-total__row rnw-total__row--grand"><span>' + window.rnwT('drawer.total','Total') + '</span><strong>$' + b.total.toFixed(2) + '</strong></div>';
        if (b.compareAt && b.compareAt.totalSavings > 0) {
          html += '<div class="rnw-total__savings">' + window.rnwTfmt('drawer.you_save_fmt','You save ${amount} on this order',{amount:b.compareAt.totalSavings.toFixed(2)}) + '</div>';
        }
        totalEl.innerHTML = html;
        setBuyEnabled(offerEl, true);
        if (hintEl) hintEl.hidden = true;
      })
      .catch(function (err) {
        totalEl.innerHTML = '<div class="rnw-total__err">' + escapeHtml(err.message) + '</div>';
        if (hintEl) { hintEl.textContent = window.rnwT('drawer.could_not_calc','Could not calculate price'); hintEl.hidden = false; }
      });
  }

  function setBuyEnabled(offerEl, enabled) {
    offerEl.querySelectorAll('.rnw-order-btn, .rnw-cart-add-btn').forEach(function (b) { b.disabled = !enabled; });
  }

  function offerSelection(offerEl) {
    var activeOriginBtn = offerEl.querySelector('.rnw-origin-opt.is-active');
    var certificates = [];
    offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
      var pct = parseInt(certEl.getAttribute('data-cert-state'), 10) || 0;
      if (pct > 0) certificates.push({ id: certEl.getAttribute('data-cert-id'), percent: pct });
    });
    return {
      offerId: offerEl.getAttribute('data-offer-id'),
      originId: activeOriginBtn ? activeOriginBtn.getAttribute('data-origin-id') : null,
      kg: parseFloat(offerEl.querySelector('.rnw-kg-input').value) || 0,
      certificates: certificates
    };
  }

  function addOfferToCart(offerEl, btn) {
    btn.disabled = true;
    window.rnwCart.add(offerSelection(offerEl)).then(function () {
      btn.disabled = false;
    });
  }

  function openOrderPane(offerEl) {
    var offerId = offerEl.getAttribute('data-offer-id');
    var kg = parseFloat(offerEl.querySelector('.rnw-kg-input').value) || 0;
    var activeOriginBtn = offerEl.querySelector('.rnw-origin-opt.is-active');
    var originId = activeOriginBtn ? activeOriginBtn.getAttribute('data-origin-id') : null;
    var certificates = [];
    offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
      var pct = parseInt(certEl.getAttribute('data-cert-state'), 10) || 0;
      if (pct > 0) certificates.push({ id: certEl.getAttribute('data-cert-id'), percent: pct });
    });
    var totalEl = offerEl.querySelector('.rnw-total');
    var totalHtml = totalEl ? totalEl.innerHTML : '';

    currentOrderDraft = { offerId: offerId, originId: originId, kg: kg, certificates: certificates };

    var summary = document.getElementById('rnw-order-summary');
    if (summary) summary.innerHTML = totalHtml;

    // Odeme secenekleri: havale yalnizca IBAN'i kayitli tedarikcide; kart yalnizca API izin veriyorsa
    var acceptsBank = offerEl.getAttribute('data-accepts-bank') === '1';
    var cardOn = paymentMethods.indexOf('iyzico') !== -1;
    var bankOpt = document.getElementById('rnw-pay-bank-opt');
    var cardOpt = document.getElementById('rnw-pay-card-opt');
    var bankRadio = orderForm.querySelector('input[name="paymentMethod"][value="bank_transfer"]');
    var cardRadio = orderForm.querySelector('input[name="paymentMethod"][value="iyzico"]');
    if (bankOpt) bankOpt.hidden = !acceptsBank;
    if (bankRadio) bankRadio.disabled = !acceptsBank;
    if (cardOpt) cardOpt.hidden = !cardOn;
    if (cardRadio) cardRadio.disabled = !cardOn;
    if (acceptsBank && bankRadio) bankRadio.checked = true;
    else if (cardOn && cardRadio) cardRadio.checked = true;
    var noPay = !acceptsBank && !cardOn;
    var payNone = document.getElementById('rnw-pay-none');
    if (payNone) {
      payNone.textContent = noPay ? lt('noPaymentMethod') : '';
      payNone.hidden = !noPay;
    }
    var submitBtn = orderForm.querySelector('.rnw-order-submit');
    if (submitBtn) submitBtn.disabled = noPay;
    var bankResult = document.getElementById('rnw-order-bank-result');
    if (bankResult) bankResult.remove();
    orderForm.hidden = false;

    listEl.hidden = true;
    orderPane.hidden = false;
    var errEl = document.getElementById('rnw-order-err');
    if (errEl) errEl.hidden = true;

    // Auth state'i tazele (cookie değişmiş olabilir)
    refreshBuyerSession().then(applyBuyerAutofill);
    orderForm.querySelector('input[name="name"]').focus();
  }

  // --- Buyer session yardımcıları ---

  function refreshBuyerSession() {
    return fetch(API_BASE + '/panel/buyer/api/me', { credentials: 'include', headers: authHeaders() })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.loggedIn && window.rnwToken && window.rnwToken.get()) window.rnwToken.set('');
        buyerSession = data.loggedIn ? data.customer : null;
        return buyerSession;
      })
      .catch(function () { buyerSession = null; return null; });
  }

  function applyBuyerAutofill() {
    var banner = document.getElementById('rnw-auth-banner');
    var savedAddrWrap = document.getElementById('rnw-saved-addresses');
    if (!orderForm) return;

    if (!buyerSession) {
      if (banner) banner.setAttribute('data-state', 'anonymous');
      if (savedAddrWrap) savedAddrWrap.hidden = true;
      return;
    }

    // Banner state
    if (banner) {
      banner.setAttribute('data-state', 'loggedin');
      var emailEl = banner.querySelector('[data-rnw-buyer-email]');
      if (emailEl) emailEl.textContent = buyerSession.email;
    }

    // Form auto-fill (sadece boş alanlar)
    function fillIfEmpty(name, value) {
      var f = orderForm.querySelector('input[name="' + name + '"]');
      if (f && !f.value && value) f.value = value;
    }
    fillIfEmpty('name', buyerSession.name);
    fillIfEmpty('email', buyerSession.email);
    fillIfEmpty('phone', buyerSession.phone);
    fillIfEmpty('companyName', buyerSession.companyName);
    fillIfEmpty('taxNumber', buyerSession.taxNumber);

    var addrs = buyerSession.addresses || [];
    if (savedAddrWrap) {
      if (addrs.length === 0) {
        savedAddrWrap.hidden = true;
      } else {
        var sel = savedAddrWrap.querySelector('[data-rnw-saved-addr]');
        if (sel) {
          sel.innerHTML = '<option value="">— Manual entry —</option>' + addrs.map(function (a, i) {
            var label = a.label ? a.label + ' — ' : '';
            var summary = label + (a.addressLine || '') + (a.city ? ', ' + a.city : '');
            return '<option value="' + i + '"' + (a.isDefault ? ' selected' : '') + '>' + escapeHtml(summary) + '</option>';
          }).join('');
          sel.onchange = function () {
            var idx = parseInt(sel.value, 10);
            if (isNaN(idx)) return;
            var a = addrs[idx];
            ['addressLine','city','district','postalCode','country'].forEach(function (k) {
              var f = orderForm.querySelector('input[name="' + k + '"]');
              if (f) f.value = a[k] || (k === 'country' ? 'Türkiye' : '');
            });
          };
          // Varsayılan adresi otomatik uygula
          var defIdx = addrs.findIndex(function (a) { return a.isDefault; });
          if (defIdx < 0) defIdx = 0;
          sel.value = String(defIdx);
          sel.onchange();
        }
        savedAddrWrap.hidden = false;
      }
    }
  }

  // --- Auth modal (Login / Register / Forgot) ---

  function openAuthModal(tab) {
    var m = document.getElementById('rnw-auth-modal');
    if (!m) return;
    switchAuthTab(tab || 'login');
    var regForm = m.querySelector('[data-rnw-auth-form="register"]');
    var regDone = m.querySelector('[data-rnw-register-done]');
    if (regForm && regDone && !regDone.hidden) { regDone.hidden = true; regForm.hidden = false; }
    // Reset error/success states
    m.querySelectorAll('[data-rnw-auth-err]').forEach(function (e) { e.hidden = true; });
    m.querySelectorAll('[data-rnw-auth-success]').forEach(function (e) { e.hidden = true; });
    m.setAttribute('aria-hidden', 'false');
    // Focus first input of active pane
    setTimeout(function () {
      var activePane = m.querySelector('[data-rnw-auth-pane]:not([hidden])');
      var firstInput = activePane && activePane.querySelector('input');
      if (firstInput) firstInput.focus();
    }, 80);
  }
  function closeAuthModal() {
    var m = document.getElementById('rnw-auth-modal');
    if (m) m.setAttribute('aria-hidden', 'true');
  }
  function switchAuthTab(tab) {
    var m = document.getElementById('rnw-auth-modal');
    if (!m) return;
    m.querySelectorAll('[data-rnw-auth-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-rnw-auth-tab') === tab);
    });
    // "forgot" tab kart sekmesinde yok, login sekmesini aktif göster
    if (tab === 'forgot') {
      m.querySelector('[data-rnw-auth-tab="login"]').classList.add('is-active');
    }
    m.querySelectorAll('[data-rnw-auth-pane]').forEach(function (p) {
      p.hidden = p.getAttribute('data-rnw-auth-pane') !== tab;
    });
  }

  function initAuthModal() {
    var modal = document.getElementById('rnw-auth-modal');
    if (!modal) return;

    // Close
    modal.querySelectorAll('[data-rnw-auth-close]').forEach(function (el) {
      el.addEventListener('click', closeAuthModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeAuthModal();
    });

    // Tab clicks (sekme + alt linkler)
    modal.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rnw-auth-tab]');
      if (t) {
        e.preventDefault();
        switchAuthTab(t.getAttribute('data-rnw-auth-tab'));
      }
    });

    function showErr(name, msg) {
      var el = modal.querySelector('[data-rnw-auth-err="' + name + '"]');
      if (el) { el.textContent = msg; el.hidden = false; }
    }
    function hideErr(name) {
      var el = modal.querySelector('[data-rnw-auth-err="' + name + '"]');
      if (el) el.hidden = true;
    }
    function showSuccess(name) {
      var el = modal.querySelector('[data-rnw-auth-success="' + name + '"]');
      if (el) el.hidden = false;
    }

    // Login
    var loginForm = modal.querySelector('[data-rnw-auth-form="login"]');
    loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      hideErr('login');
      var fd = new FormData(loginForm);
      var btn = loginForm.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = window.rnwT('drawer.signing_in','Signing in...');
      fetch(API_BASE + '/panel/buyer/api/login', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: fd.get('email'), password: fd.get('password') })
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false; btn.textContent = window.rnwT('auth.sign_in','Sign in');
        if (!res.ok) {
          showErr('login', res.data.error || window.rnwT('drawer.signin_failed','Sign in failed'));
          if (res.data.needsPasswordSetup) {
            setTimeout(function () { switchAuthTab('forgot'); }, 1200);
          }
          return;
        }
        if (res.data.sessionToken && window.rnwToken) window.rnwToken.set(res.data.sessionToken);
        buyerSession = res.data.customer;
        refreshBuyerSession().then(function () {
          applyBuyerAutofill();
          closeAuthModal();
          if (onAuthSuccess) { var cb = onAuthSuccess; onAuthSuccess = null; cb(); }
        });
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Sign in';
        showErr('login', window.rnwT('drawer.connection_error',(window.rnwT?window.rnwT('common.error_connection',"Connection error"):"Connection error")));
      });
    });

    // Register — kurumsal alici basvurusu (alanlar renneway-register.js ile cizilir)
    var registerForm = modal.querySelector('[data-rnw-auth-form="register"]');
    var registerFields = modal.querySelector('[data-rnw-register-fields]');
    var registerDone = modal.querySelector('[data-rnw-register-done]');
    if (window.rnwRegister && registerFields) window.rnwRegister.mount(registerFields);

    registerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      hideErr('register');
      if (!window.rnwRegister) return;
      var body = window.rnwRegister.collect(registerForm);
      var btn = registerForm.querySelector('button[type=submit]');
      var btnLabel = window.rnwRegister.label('submit');
      btn.disabled = true; btn.textContent = window.rnwRegister.label('submitting');
      fetch(API_BASE + '/panel/buyer/api/register', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false; btn.textContent = btnLabel;
        if (!res.ok) {
          showErr('register', res.data.error || (window.rnwT?window.rnwT('account.error_registration_failed',"Registration failed"):"Registration failed"));
          window.rnwRegister.markError(registerForm, res.data.field);
          var err = modal.querySelector('[data-rnw-auth-err="register"]');
          if (err && !res.data.field && err.scrollIntoView) err.scrollIntoView({ block: 'center' });
          return;
        }
        if (res.data.sessionToken && window.rnwToken) window.rnwToken.set(res.data.sessionToken);
        buyerSession = res.data.customer;
        window.rnwRegister.markError(registerForm, null);
        if (res.data.customer && res.data.customer.priceAccess !== 'approved' && registerDone) {
          registerForm.hidden = true;
          registerDone.hidden = false;
          registerDone.querySelector('[data-rnw-register-done-title]').textContent = window.rnwRegister.label('receivedTitle');
          registerDone.querySelector('[data-rnw-register-done-body]').textContent = window.rnwRegister.label('receivedBody');
        }
        refreshBuyerSession().then(function () {
          applyBuyerAutofill();
          if (onAuthSuccess) { var cb = onAuthSuccess; onAuthSuccess = null; cb(); }
          if (!registerDone || registerDone.hidden) closeAuthModal();
        });
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = btnLabel;
        showErr('register', (window.rnwT?window.rnwT('common.error_connection',"Connection error"):"Connection error"));
      });
    });

    // Forgot password
    var forgotForm = modal.querySelector('[data-rnw-auth-form="forgot"]');
    forgotForm.addEventListener('submit', function (e) {
      e.preventDefault();
      hideErr('forgot');
      var successEl = modal.querySelector('[data-rnw-auth-success="forgot"]');
      if (successEl) successEl.hidden = true;
      var fd = new FormData(forgotForm);
      var btn = forgotForm.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = window.rnwT('drawer.sending','Sending...');
      fetch(API_BASE + '/panel/buyer/api/password-reset/request', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: fd.get('email') })
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false; btn.textContent = 'Send reset link';
        if (!res.ok) { showErr('forgot', res.data.error || 'Failed to send'); return; }
        showSuccess('forgot');
        forgotForm.reset();
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Send reset link';
        showErr('forgot', (window.rnwT?window.rnwT('common.error_connection',"Connection error"):"Connection error"));
      });
    });
  }

  function initAuthBanner() {
    document.addEventListener('click', function (e) {
      // Popup içindeki "Sign in" linki
      if (e.target.closest('[data-rnw-signin]')) {
        e.preventDefault();
        openAuthModal('login');
      }
      // Header ikonu Shopify'ın kendi /pages/account sayfasına gider — JS intercept yok
      // Logout
      if (e.target.closest('[data-rnw-logout]')) {
        e.preventDefault();
        fetch(API_BASE + '/panel/buyer/api/logout', { method: 'POST', credentials: 'include', headers: authHeaders({ 'Content-Type': 'application/json' }), body: '{}' })
          .then(function () {
            if (window.rnwToken) window.rnwToken.set('');
            buyerSession = null;
            applyBuyerAutofill();
          });
      }
    });
  }

  function showOffersList() {
    if (orderPane) orderPane.hidden = true;
    listEl.hidden = false;
  }

  function bindNegotiateUx(offerEl) {
    var details = offerEl.querySelector('[data-rnw-negotiate]');
    if (!details) return;
    var summary = details.querySelector('summary');
    var totalInput = details.querySelector('[data-rnw-negotiate-total]');
    var breakdown = details.querySelector('[data-rnw-negotiate-breakdown]');

    function getKg() { return parseFloat(offerEl.querySelector('.rnw-kg-input').value) || 0; }
    function activeOriginPrice() {
      var b = offerEl.querySelector('.rnw-origin-opt.is-active');
      return b ? (parseFloat(b.getAttribute('data-price')) || 0) : 0;
    }
    function getSelectedCerts() {
      var sel = [];
      offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
        var pct = parseInt(certEl.getAttribute('data-cert-state'), 10) || 0;
        if (pct <= 0) return;
        var nameEl = certEl.querySelector('.rnw-cert__name');
        var activeOpt = certEl.querySelector('.rnw-cert__opt[data-pct="' + pct + '"]');
        var priceKg = activeOpt ? (parseFloat(activeOpt.getAttribute('data-price')) || 0) : 0;
        sel.push({
          name: nameEl ? nameEl.textContent : 'Certificate',
          percent: pct,
          pricePerKg: priceKg
        });
      });
      return sel;
    }
    function updateBreakdown() {
      if (!breakdown) return;
      var kg = getKg();
      var list = activeOriginPrice();
      var total = parseFloat(totalInput.value) || 0;
      var sel = getSelectedCerts();
      var certsTotal = sel.reduce(function (s, c) { return s + kg * c.pricePerKg; }, 0);
      var listYarnTotal = kg * list;
      var listGrandTotal = listYarnTotal + certsTotal;
      var certsHtml = sel.length
        ? sel.map(function (c) {
            return '<span style="display:inline-block; padding:2px 8px; margin:2px 4px 0 0; background:#fff; border:1px solid #e2e8f0; border-radius:999px; font-size:11px;">' +
              c.name + ' ' + c.percent + '% (+$' + c.pricePerKg.toFixed(2) + '/kg = $' + (kg * c.pricePerKg).toFixed(2) + ')</span>';
          }).join('')
        : '<span style="color:#6b7280; font-size:12px;">No certificates selected — add them above before negotiating if needed.</span>';
      if (!kg || !list) { breakdown.innerHTML = certsHtml; return; }
      var yarnTotal = total > 0 ? Math.max(0, total - certsTotal) : 0;
      var yarnPerKg = kg > 0 && yarnTotal > 0 ? yarnTotal / kg : 0;
      var savings = total > 0 ? listGrandTotal - total : 0;
      var savingsPct = savings > 0 && listGrandTotal > 0 ? Math.round((savings / listGrandTotal) * 100) : 0;
      var lowYarnWarn = total > 0 && yarnTotal <= 0
        ? '<div style="margin-top:6px; padding:6px 10px; background:#fee2e2; color:#991b1b; border-radius:6px; font-size:11.5px;">Your total ($' + total.toFixed(2) + ') is too low to cover the selected certificates ($' + certsTotal.toFixed(2) + '). Raise your total or remove certificates.</div>'
        : '';
      var ratioWarn = total > 0 && yarnPerKg > 0 && yarnPerKg >= list
        ? '<div style="margin-top:6px; padding:6px 10px; background:#fef3c7; color:#92400e; border-radius:6px; font-size:11.5px;">Derived yarn $' + yarnPerKg.toFixed(2) + '/kg is not lower than list $' + list.toFixed(2) + '/kg — lower your total to make a real discount.</div>'
        : '';
      breakdown.innerHTML =
        '<div class="rnw-negotiate__row-out">' +
          '<span style="font-size:11px; color:#6b7280;">List package: yarn $' + listYarnTotal.toFixed(2) + ' + certs $' + certsTotal.toFixed(2) + ' = <s>$' + listGrandTotal.toFixed(2) + '</s></span>' +
          (total > 0 ? '<span>Derived: yarn $' + yarnTotal.toFixed(2) + ' (=$' + yarnPerKg.toFixed(2) + '/kg) + certs $' + certsTotal.toFixed(2) + ' = <strong>$' + total.toFixed(2) + '</strong></span>' : '') +
          (savings > 0 ? '<span class="rnw-negotiate__savings">Save $' + savings.toFixed(2) + ' (' + savingsPct + '%)</span>' : '') +
          '<div style="margin-top:6px; padding-top:6px; border-top:1px dashed #e2e8f0;">' + certsHtml + '</div>' +
          lowYarnWarn + ratioWarn +
        '</div>';
    }

    if (totalInput) totalInput.addEventListener('input', updateBreakdown);

    // Summary'ye tıklayınca smooth scroll
    if (summary) {
      summary.addEventListener('click', function () {
        requestAnimationFrame(function () {
          if (details.open) {
            details.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (totalInput) setTimeout(function () { totalInput.focus(); }, 240);
          }
        });
      });
    }

    // kg ve cert değişince breakdown'u tazele
    var kgInput = offerEl.querySelector('.rnw-kg-input');
    if (kgInput) kgInput.addEventListener('input', updateBreakdown);
    // Cert tier buton tıklamaları offerEl seviyesinde — generic dinleyici
    offerEl.addEventListener('click', function (e) {
      if (e.target.closest('.rnw-cert__opt')) {
        // Tier seçimi after-mutation event'i için: bir sonraki frame'de update
        requestAnimationFrame(updateBreakdown);
      }
    }, true);
  }

  // ---- Numune talebi ----

  function toggleSampleForm(offerEl, forceClose) {
    var form = offerEl.querySelector('[data-rnw-sample-form]');
    var msg = offerEl.querySelector('[data-rnw-sample-msg]');
    if (!form) return;
    if (forceClose) { form.hidden = true; return; }

    // Login kontrolu — giris/kayit modalina yonlendir, basarili giriste form aktif acilir
    if (!buyerSession) {
      if (msg) {
        msg.hidden = false;
        msg.className = 'rnw-sample-msg is-err';
        msg.textContent = window.rnwT('drawer.sample_login_first', 'Please sign in to request a sample.');
        form.hidden = false;
        form.querySelectorAll('textarea,input,button.rnw-sample-send:not([data-rnw-sample-login])').forEach(function (el) { el.disabled = true; });
        if (!form.querySelector('[data-rnw-sample-login]')) {
          var loginBtn = document.createElement('button');
          loginBtn.type = 'button';
          loginBtn.setAttribute('data-rnw-sample-login', '');
          loginBtn.className = 'rnw-sample-send';
          loginBtn.textContent = window.rnwT('drawer.login_register_btn', 'Sign in / Register');
          loginBtn.addEventListener('click', function () {
            onAuthSuccess = function () {
              var loginBtnNow = form.querySelector('[data-rnw-sample-login]');
              if (loginBtnNow) loginBtnNow.remove();
              form.querySelectorAll('textarea,input,button.rnw-sample-send').forEach(function (el) { el.disabled = false; });
              msg.hidden = true;
              form.hidden = true;
              toggleSampleForm(offerEl);
            };
            openAuthModal('login');
          });
          msg.insertAdjacentElement('afterend', loginBtn);
        }
      }
      return;
    }
    form.hidden = !form.hidden;
    if (!form.hidden) {
      // Kayitli default adresi otomatik doldur
      var addrEl = form.querySelector('.rnw-sample-addr');
      if (addrEl && !addrEl.value && buyerSession.defaultAddress) {
        var a = buyerSession.defaultAddress;
        addrEl.value = [a.addressLine, a.district, a.city, a.postalCode, a.country].filter(Boolean).join(', ');
      }
    }
  }

  function submitSampleRequest(offerEl) {
    var offerId = offerEl.getAttribute('data-offer-id');
    var form = offerEl.querySelector('[data-rnw-sample-form]');
    var msg = offerEl.querySelector('[data-rnw-sample-msg]');
    var sendBtn = offerEl.querySelector('[data-rnw-sample-send]');
    if (!form) return;

    var addr = (form.querySelector('.rnw-sample-addr') || {}).value || '';
    var note = (form.querySelector('.rnw-sample-note') || {}).value || '';
    if (!addr.trim()) {
      msg.hidden = false; msg.className = 'rnw-sample-msg is-err';
      msg.textContent = window.rnwT('drawer.sample_addr_label', 'Delivery address') + '!';
      return;
    }

    // Tedarikci id'si offers datasindan — renderOffer'da data-supplier-id yazmadik,
    // API zaten offerId'den supplier'i buluyor; supplierId'yi offers listesinden cek
    var supplierId = offerEl.getAttribute('data-supplier-id') || '';

    sendBtn.disabled = true;
    sendBtn.textContent = window.rnwT('drawer.sample_sending', 'Sending…');

    fetch(API_BASE + '/panel/buyer/api/sample-requests', {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      credentials: 'include',
      body: JSON.stringify({
        offerId: offerId,
        supplierId: supplierId,
        shippingAddress: { addressLine: addr.trim() },
        note: note.trim()
      })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        sendBtn.disabled = false;
        sendBtn.textContent = window.rnwT('drawer.sample_send_btn', 'Send request');
        msg.hidden = false;
        if (res.ok && res.body.ok) {
          msg.className = 'rnw-sample-msg is-ok';
          msg.textContent = window.rnwT('drawer.sample_sent', 'Sample request sent! Track it in My Account.');
          form.querySelectorAll('textarea,input').forEach(function (el) { el.value = ''; });
          setTimeout(function () { form.hidden = true; msg.hidden = true; }, 4000);
        } else {
          msg.className = 'rnw-sample-msg is-err';
          msg.textContent = res.body.error || 'Error';
        }
      })
      .catch(function () {
        sendBtn.disabled = false;
        sendBtn.textContent = window.rnwT('drawer.sample_send_btn', 'Send request');
        msg.hidden = false; msg.className = 'rnw-sample-msg is-err';
        msg.textContent = window.rnwT('common.error_connection', 'Connection error');
      });
  }

  // ---- RFQ (fiyat girilmemis variant → talep gonder, tum tedarikcilere gider) ----

  function renderRfqForm() {
    var noOffersMsg = window.rnwT('drawer.no_offers_for_variant', 'No offers yet for this variant.');
    var yarnDefault = (productData && productData.title) || '';
    var infoLine = escapeHtml((selection.number || '—') + ' / ' + (selection.color || '—'));

    listEl.innerHTML =
      '<div class="renneway-empty" style="padding-bottom:8px">' + noOffersMsg + '</div>' +
      '<div class="rnw-rfq" data-rnw-rfq>' +
        '<div class="rnw-rfq__title">' + window.rnwT('drawer.rfq_title', 'Request a quote') + '</div>' +
        '<div class="rnw-rfq__intro">' + window.rnwT('drawer.rfq_intro', 'Send a request — it goes to all suppliers. Quotes appear under "My Requests" in your account and you get an email.') + '</div>' +
        '<label class="rnw-rfq__label">' + window.rnwT('drawer.rfq_yarn_label', 'Yarn name') + '</label>' +
        '<input type="text" class="rnw-rfq__input" data-rnw-rfq-yarn maxlength="200" value="' + escapeAttr(yarnDefault) + '">' +
        '<div class="rnw-rfq__variant">' + window.rnwT('drawer.number_label', 'Number') + ' / ' + window.rnwT('drawer.color_label', 'Color') + ': <strong>' + infoLine + '</strong></div>' +
        '<div class="rnw-rfq__row">' +
          '<div>' +
            '<label class="rnw-rfq__label">' + window.rnwT('drawer.rfq_kg_label', 'Quantity (kg)') + '</label>' +
            '<input type="number" class="rnw-rfq__input" data-rnw-rfq-kg min="1" step="1" placeholder="1000">' +
          '</div>' +
          '<div>' +
            '<label class="rnw-rfq__label">' + window.rnwT('drawer.rfq_target_label', 'Target price ($/kg, optional)') + '</label>' +
            '<input type="number" class="rnw-rfq__input" data-rnw-rfq-target min="0" step="0.01" placeholder="3.25">' +
          '</div>' +
          '<div>' +
            '<label class="rnw-rfq__label">' + window.rnwT('drawer.rfq_lead_label', 'Lead time (days, optional)') + '</label>' +
            '<input type="number" class="rnw-rfq__input" data-rnw-rfq-lead min="1" step="1" placeholder="30">' +
          '</div>' +
        '</div>' +
        '<label class="rnw-rfq__label">' + window.rnwT('drawer.rfq_note_label', 'Note (optional)') + '</label>' +
        '<textarea class="rnw-rfq__input rnw-rfq__note" data-rnw-rfq-note maxlength="1000" rows="2"></textarea>' +
        '<button type="button" class="rnw-rfq__send" data-rnw-rfq-send>' + window.rnwT('drawer.rfq_send_btn', 'Send request') + '</button>' +
        '<div class="rnw-sample-msg" data-rnw-rfq-msg hidden></div>' +
      '</div>';

    var wrap = listEl.querySelector('[data-rnw-rfq]');
    var msg = wrap.querySelector('[data-rnw-rfq-msg]');

    // Login yoksa form gorunur ama disabled — giris/kayit modalina yonlendir,
    // basarili giriste form yeniden (aktif olarak) render edilir
    if (!buyerSession) {
      msg.hidden = false;
      msg.className = 'rnw-sample-msg is-err';
      msg.textContent = window.rnwT('drawer.rfq_login_first', 'Please sign in to send a request.');
      wrap.querySelectorAll('input,textarea,button').forEach(function (el) { el.disabled = true; });
      var loginBtn = document.createElement('button');
      loginBtn.type = 'button';
      loginBtn.className = 'rnw-rfq__send';
      loginBtn.textContent = window.rnwT('drawer.login_register_btn', 'Sign in / Register');
      loginBtn.addEventListener('click', function () {
        onAuthSuccess = renderRfqForm;
        openAuthModal('login');
      });
      msg.insertAdjacentElement('afterend', loginBtn);
      return;
    }

    wrap.querySelector('[data-rnw-rfq-send]').addEventListener('click', submitRfq);
  }

  function submitRfq() {
    var wrap = listEl.querySelector('[data-rnw-rfq]');
    if (!wrap) return;
    var msg = wrap.querySelector('[data-rnw-rfq-msg]');
    var sendBtn = wrap.querySelector('[data-rnw-rfq-send]');
    var yarnName = (wrap.querySelector('[data-rnw-rfq-yarn]').value || '').trim();
    var kg = parseFloat(wrap.querySelector('[data-rnw-rfq-kg]').value);
    var target = wrap.querySelector('[data-rnw-rfq-target]').value;
    var lead = wrap.querySelector('[data-rnw-rfq-lead]').value;
    var note = (wrap.querySelector('[data-rnw-rfq-note]').value || '').trim();

    function err(text) {
      msg.hidden = false;
      msg.className = 'rnw-sample-msg is-err';
      msg.textContent = text;
    }
    if (!yarnName) return err(window.rnwT('drawer.rfq_yarn_label', 'Yarn name') + '!');
    if (!kg || kg < 1) return err(window.rnwT('drawer.rfq_kg_label', 'Quantity (kg)') + '!');

    sendBtn.disabled = true;
    sendBtn.textContent = window.rnwT('drawer.sample_sending', 'Sending…');

    fetch(API_BASE + '/panel/buyer/api/rfqs', {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      credentials: 'include',
      body: JSON.stringify({
        yarnName: yarnName,
        kg: Math.round(kg),
        targetPricePerKg: target !== '' ? parseFloat(target) : null,
        leadTimeDays: lead !== '' ? parseInt(lead, 10) : null,
        note: note,
        handle: productData ? productData.handle : '',
        number: selection.number || '',
        color: selection.color || ''
      })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        sendBtn.disabled = false;
        sendBtn.textContent = window.rnwT('drawer.rfq_send_btn', 'Send request');
        msg.hidden = false;
        if (res.ok && res.body.ok) {
          msg.className = 'rnw-sample-msg is-ok';
          msg.textContent = window.rnwT('drawer.rfq_sent', 'Request sent to all suppliers! Track quotes under My Requests in your account.');
          wrap.querySelectorAll('input[type=number],textarea').forEach(function (el) { el.value = ''; });
        } else {
          msg.className = 'rnw-sample-msg is-err';
          msg.textContent = res.body.error || 'Error';
        }
      })
      .catch(function () {
        sendBtn.disabled = false;
        sendBtn.textContent = window.rnwT('drawer.rfq_send_btn', 'Send request');
        err(window.rnwT('common.error_connection', 'Connection error'));
      });
  }

  function submitNegotiation(offerEl) {
    var offerId = offerEl.getAttribute('data-offer-id');
    var activeOriginBtn = offerEl.querySelector('.rnw-origin-opt.is-active');
    var originId = activeOriginBtn ? activeOriginBtn.getAttribute('data-origin-id') : null;
    var listPrice = activeOriginBtn ? parseFloat(activeOriginBtn.getAttribute('data-price')) : null;
    // kg integer'a yuvarla — float drift'i daha kaynak noktasında engeller
    var kgRaw = parseFloat(offerEl.querySelector('.rnw-kg-input').value);
    var kg = Math.round(kgRaw);
    var totalInput = offerEl.querySelector('[data-rnw-negotiate-total]');
    var msgEl = offerEl.querySelector('[data-rnw-negotiate-message]');
    var feedback = offerEl.querySelector('[data-rnw-negotiate-msg]');
    var submitBtn = offerEl.querySelector('[data-rnw-negotiate-submit]');
    // total: kullanıcının yazdığı değer 2 ondalığa yuvarlanır (display-safe)
    var totalAmount = Math.round((parseFloat(totalInput.value) || 0) * 100) / 100;

    // Seçili sertifikaları topla
    var negotiateCerts = [];
    offerEl.querySelectorAll('.rnw-cert').forEach(function (certEl) {
      var pct = parseInt(certEl.getAttribute('data-cert-state'), 10) || 0;
      if (pct > 0) negotiateCerts.push({ certificateId: certEl.getAttribute('data-cert-id'), percent: pct });
    });

    function showMsg(text, kind) {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = text;
      feedback.setAttribute('data-kind', kind || 'err');
    }

    if (!originId) { showMsg('Please select an origin first.', 'err'); return; }
    if (!kg || kg <= 0) { showMsg('Please enter quantity in kg.', 'err'); return; }
    if (!totalAmount || totalAmount <= 0) { showMsg('Please enter your total offer.', 'err'); return; }
    if (listPrice) {
      var certsTotal = negotiateCerts.reduce(function (s, c) {
        var optEl = offerEl.querySelector('.rnw-cert[data-cert-id="' + c.certificateId + '"] .rnw-cert__opt[data-pct="' + c.percent + '"]');
        var pkg = optEl ? (parseFloat(optEl.getAttribute('data-price')) || 0) : 0;
        return s + kg * pkg;
      }, 0);
      var listGrand = kg * listPrice + certsTotal;
      if (totalAmount >= listGrand) { showMsg('Your total must be lower than the list package ($' + listGrand.toFixed(2) + ') for a real discount.', 'err'); return; }
      if (totalAmount <= certsTotal) { showMsg('Your total ($' + totalAmount.toFixed(2) + ') must exceed the certificate cost ($' + certsTotal.toFixed(2) + ').', 'err'); return; }
    }

    submitBtn.disabled = true; submitBtn.textContent = window.rnwT('drawer.sending','Sending...');
    feedback.hidden = true;

    fetch(API_BASE + '/panel/buyer/api/negotiations', {
      method: 'POST',
      credentials: 'include',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        offerId: offerId,
        originId: originId,
        kg: kg,
        totalAmount: totalAmount,
        certificates: negotiateCerts,
        message: msgEl ? msgEl.value : ''
      })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, status: r.status, body: body }; }); })
      .then(function (res) {
        submitBtn.disabled = false; submitBtn.textContent = window.rnwT('drawer.send_offer','Send offer');
        if (res.status === 401) {
          showMsg('Please sign in to send a counter offer. Visit /pages/account', 'err');
          return;
        }
        if (!res.ok) {
          showMsg(res.body.error || 'Could not create offer.', 'err');
          return;
        }
        showMsg('Offer sent! The supplier will get an email. You can track this on your account page.', 'ok');
        totalInput.value = '';
        if (msgEl) msgEl.value = '';
      })
      .catch(function (err) {
        submitBtn.disabled = false; submitBtn.textContent = window.rnwT('drawer.send_offer','Send offer');
        showMsg('Network error: ' + err.message, 'err');
      });
  }

  function onOrderSubmit(e) {
    e.preventDefault();
    if (!currentOrderDraft) return;

    var fd = new FormData(orderForm);
    var buyer = {};
    // Shipping/payment fields are submitted on the same form but should not bleed into buyer.*
    var shippingKeys = ['shippingPreference', 'carrierName', 'carrierAddress', 'carrierPhone', 'carrierCustomerCode', 'paymentMethod'];
    fd.forEach(function (val, key) {
      if (shippingKeys.indexOf(key) === -1) buyer[key] = val;
    });
    var paymentMethod = fd.get('paymentMethod') || 'bank_transfer';

    var shipping = { preference: fd.get('shippingPreference') || '' };
    if (shipping.preference === 'own_carrier') {
      shipping.carrierName = (fd.get('carrierName') || '').trim();
      shipping.carrierAddress = (fd.get('carrierAddress') || '').trim();
      shipping.carrierPhone = (fd.get('carrierPhone') || '').trim();
      shipping.customerCode = (fd.get('carrierCustomerCode') || '').trim();
    }

    var submitBtn = orderForm.querySelector('.rnw-order-submit');
    var labelEl = submitBtn.querySelector('.rnw-order-submit__label');
    submitBtn.disabled = true;
    var idleLabel = labelEl.getAttribute('data-label') || labelEl.textContent;
    labelEl.textContent = labelEl.getAttribute('data-busy') || idleLabel;

    var errEl = document.getElementById('rnw-order-err');
    errEl.hidden = true;

    fetch(API_BASE + '/api/public/orders', {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        offerId: currentOrderDraft.offerId,
        originId: currentOrderDraft.originId,
        kg: currentOrderDraft.kg,
        certificates: currentOrderDraft.certificates,
        buyer: buyer,
        shipping: shipping,
        paymentMethod: paymentMethod
      })
    })
    .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
    .then(function (res) {
      if (!res.ok || (!res.body.paymentPageUrl && !res.body.bankTransfer)) {
        errEl.textContent = res.body.error || 'Could not start payment.';
        errEl.hidden = false;
        submitBtn.disabled = false;
        labelEl.textContent = idleLabel;
        return;
      }
      if (res.body.bankTransfer) {
        showBankTransferResult(res.body);
        submitBtn.disabled = false;
        labelEl.textContent = idleLabel;
        return;
      }
      labelEl.textContent = 'Redirecting to payment...';
      window.location.href = res.body.paymentPageUrl;
    })
    .catch(function (err) {
      errEl.textContent = 'Network error: ' + err.message;
      errEl.hidden = false;
      submitBtn.disabled = false;
      labelEl.textContent = idleLabel;
    });
  }

  // Havale siparisi olusturuldu — form yerine banka bilgileri panelini goster
  function showBankTransferResult(body) {
    var bt = body.bankTransfer;
    var panel = document.createElement('div');
    panel.id = 'rnw-order-bank-result';
    panel.className = 'rnw-bank-result';
    panel.innerHTML =
      '<div class="rnw-bank-result__ok">✓ ' + window.rnwT('form.bank_order_created', 'Your order has been created!') + '</div>' +
      '<div class="rnw-bank-result__no">' + window.rnwT('form.order_no', 'Order no') + ': <strong>' + escapeHtml(body.orderNumber) + '</strong></div>' +
      '<div class="rnw-bank-result__box">' +
        '<div class="rnw-bank-result__title">' + window.rnwT('form.bank_details', 'Bank transfer details') + '</div>' +
        (bt.bankName ? '<div><span>' + window.rnwT('form.bank_name', 'Bank') + ':</span> <strong>' + escapeHtml(bt.bankName) + (bt.branch ? ' / ' + escapeHtml(bt.branch) : '') + '</strong></div>' : '') +
        (bt.accountHolder ? '<div><span>' + window.rnwT('form.bank_holder', 'Account holder') + ':</span> <strong>' + escapeHtml(bt.accountHolder) + '</strong></div>' : '') +
        '<div><span>IBAN:</span> <strong style="user-select:all">' + escapeHtml(bt.iban) + '</strong></div>' +
        '<div><span>' + window.rnwT('form.bank_amount', 'Amount') + ':</span> <strong>' + Number(bt.totalTRY).toLocaleString('tr-TR') + ' TL</strong> ($' + Number(bt.totalUSD).toFixed(2) + ')</div>' +
        '<div><span>' + window.rnwT('form.bank_ref', 'Reference (write in description)') + ':</span> <strong>' + escapeHtml(bt.reference) + '</strong></div>' +
      '</div>' +
      '<div class="rnw-bank-result__hint">' + window.rnwT('form.bank_after_hint', 'After making the transfer, go to My Account → My Orders and click "I made the transfer". The supplier will confirm and start preparing your order.') + '</div>' +
      '<a class="rnw-bank-result__link" href="/pages/account#orders">' + window.rnwT('form.go_account', 'Go to My Account') + ' →</a>';
    orderForm.hidden = true;
    orderForm.parentElement.insertBefore(panel, orderForm);
  }

  function absoluteUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return API_BASE + path;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return escapeHtml(s); }
})();
